import { CustomModule, fieldName, isInput, toHealthieAnswer } from "./FormField"

export interface HealthieAnswer {
  custom_module_id: string
  answer: string
}

// RHF values → Healthie `form_answers`, one per answerable module (display-only and
// unsupported modules contribute nothing).
export function serializeAnswers(modules: CustomModule[], values: Record<string, unknown>): HealthieAnswer[] {
  const answers: HealthieAnswer[] = []
  for (const mod of modules) {
    if (isInput(mod)) {
      answers.push({ custom_module_id: mod.id, answer: toHealthieAnswer(mod, values[fieldName(mod)]) })
    }
  }
  return answers
}
